import { Table } from 'antd'
import { ColumnType, TablePaginationConfig } from 'antd/lib/table/interface'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import {
  CardEntity,
  DebtEntity,
  EmployeeEntity,
  ExpenseEntity,
  FuelEntity,
  GroupApiEntity,
  PriceChangeHistoryEntity,
  PumpEntity,
  PumpShiftEntity,
  ReceiptEntity,
  ShiftEntity,
  StationEntity,
  SupplierEntity,
  TankEntity,
  TankStatisticEntity,
  TransactionEntity,
  UserEntity,
} from '../../models'
import { WorkScheduleEntity } from '../../models/workSchedule/workSchedule'

type TableComponentProps = {
  data:
    | EmployeeEntity[]
    | FuelEntity[]
    | PumpEntity[]
    | StationEntity[]
    | SupplierEntity[]
    | TankEntity[]
    | UserEntity[]
    | GroupApiEntity[]
    | ShiftEntity[]
    | WorkScheduleEntity[]
    | PriceChangeHistoryEntity[]
    | CardEntity[]
    | ReceiptEntity[]
    | DebtEntity[]
    | TransactionEntity[]
    | PumpShiftEntity[]
    | ExpenseEntity[]
    | TankStatisticEntity[]
  columns: ColumnType<any>[]
  loading: boolean
  paginationConfig?: TablePaginationConfig
  onChange?: (pagination: TablePaginationConfig) => void
  footer?: () => React.ReactElement
}

export const TableComponent: React.FC<TableComponentProps> = ({
  data,
  columns,
  loading,
  paginationConfig,
  onChange,
  ...rest
}) => {
  const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

  const pageSize =
    paginationConfig && paginationConfig.pageSize
      ? paginationConfig.pageSize
      : 15
  return (
    <Table
      bordered
      pagination={
        data.length > pageSize ||
        (paginationConfig &&
          paginationConfig.total &&
          paginationConfig.total > pageSize)
          ? {
              position: ['bottomCenter'],
              showSizeChanger: false,
              pageSize,
              ...paginationConfig,
            }
          : false
      }
      loading={loading}
      columns={columns}
      dataSource={data.map((item: any, index: number) => ({
        ...item,
        key: index,
      }))}
      scroll={{ x: isDesktopScreen ? '90vw' : '100vw' }}
      size="small"
      onChange={onChange}
      {...rest}
    />
  )
}
